/**
 * Remote Snapshot Tracking
 *
 * Tracks remote lot IDs to detect new lots during sync operations
 * @module portal/modules/lotOperations/snapshot
 */

import { Lot } from '../types';

/**
 * Track remote snapshot for new lot detection
 */
let knownRemoteLotIds = new Set<string>();
let remoteSnapshotInitialized = false;

/**
 * Reset the remote snapshot tracking
 */
export function resetRemoteSnapshot(): void {
  knownRemoteLotIds = new Set();
  remoteSnapshotInitialized = false;
}

/**
 * Apply remote snapshot and detect new lots
 * @returns Array of new lot IDs (empty on first initialization)
 */
export function applyRemoteSnapshot(lots: Lot[]): string[] {
  const incomingIds = new Set<string>();
  const newIds: string[] = [];
  for (let i = 0; i < lots.length; i++) {
    const lot = lots[i];
    if (!lot || !lot.id) {
      continue;
    }
    incomingIds.add(lot.id);
    if (remoteSnapshotInitialized && !knownRemoteLotIds.has(lot.id)) {
      newIds.push(lot.id);
    }
  }
  knownRemoteLotIds = incomingIds;
  const wasInitialized = remoteSnapshotInitialized;
  remoteSnapshotInitialized = true;
  return wasInitialized ? newIds : [];
}
